import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { WkoHighchart } from "../WkoHighchart";
const getChartOptions = (points) => ({
    chart: {
        type: "bar",
        height: 220,
        marginTop: 10,
        spacingLeft: 5,
        spacingRight: 5,
    },
    title: { text: undefined },
    exporting: { enabled: false },
    xAxis: {
        categories: [""],
        title: { text: undefined },
        labels: { enabled: false },
        lineWidth: 0,
        tickLength: 0,
        type: undefined,
    },
    yAxis: {
        min: 0,
        title: { text: undefined },
        endOnTick: false,
    },
    legend: {
        enabled: true,
        layout: "horizontal",
        verticalAlign: "bottom",
        align: "center",
        labelFormatter: function () {
            return this.name.length > 20 ? `${this.name.substring(0, 20)}...` : this.name;
        },
    },
    tooltip: {
        formatter: function () {
            return `<b>${this.series.name}</b>: ${this.y} days`;
        },
    },
    plotOptions: {
        bar: {
            stacking: "normal",
            dataLabels: { enabled: false },
            groupPadding: 0.1,
            pointWidth: 40,
        },
    },
    series: points.map((point) => ({
        type: "bar",
        name: point.name,
        data: [point.y],
    })),
});
const mapPoints = (activityNcs) => activityNcs.map((item) => ({
    name: item.Activity,
    y: item.NcCount,
}));
export const ActivityNcsChart = ({ options }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [activityNcs, setActivityNcs] = useState([]);
    useEffect(() => {
        if (!options.isReady) {
            setIsLoading(false);
            setHasResult(false);
            setErrorMessage("");
            setActivityNcs([]);
            return;
        }
        setIsLoading(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/operational/activityncs?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setActivityNcs(data === null ? [] : data);
            setHasResult(true);
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching operational patterns");
        })
            .finally(() => setIsLoading(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    const points = mapPoints(activityNcs);
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "NCs by activity" }), _jsxs("div", { className: "card-body", children: [(!options.isReady || isLoading) && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), hasResult && !isLoading && activityNcs.length > 0 && (_jsx(WkoHighchart, { options: getChartOptions(points) })), hasResult && !isLoading && activityNcs.length === 0 && !errorMessage && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] }));
};
